module.exports = __webpack_public_path__ + "img/iris_spinner.39d1a4c7.gif";